import { createAction } from 'redux-act';

export const setTourActive = createAction<boolean>();